import { useState, useEffect } from 'react';
import BookingModal from './BookingModal';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="relative min-h-screen overflow-hidden">
        {/* Navigation */}
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}>
          <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/21995c5825c642d6891c093f25dcdedd.png" 
                alt="WealthWiseConsulting" 
                className="h-10 w-auto"
              />
            </div>
            <div className="flex items-center gap-8">
              <a href="#industries" className={`text-sm font-medium transition-colors hover:text-cyan-400 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}>Industries</a>
              <a href="#services" className={`text-sm font-medium transition-colors hover:text-cyan-400 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}>Services</a>
              <a href="#approach" className={`text-sm font-medium transition-colors hover:text-cyan-400 ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}>Approach</a>
              <button 
                onClick={() => setShowBookingModal(true)}
                className="px-6 py-2.5 bg-cyan-400 text-slate-900 rounded-full text-sm font-semibold hover:bg-cyan-300 transition-all whitespace-nowrap cursor-pointer"
              >
                Book a Call
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Background */}
        <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/059d1fc440f1ff4d644d3b2854838930.jpg')`
        }}>
          <div className="absolute inset-0 bg-gradient-to-b from-midnight-navy/80 via-midnight-navy/70 to-midnight-navy/80"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 pt-32 pb-20 min-h-screen flex items-center">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center w-full">
            {/* Left Content */}
            <div className="space-y-8">
              <div>
                <h1 className="text-7xl font-bold leading-tight">
                  <span className="text-white block">Intelligent Growth</span>
                  <span className="text-cyan-300 block text-6xl font-medium mt-2">for Service-Driven</span>
                  <span className="text-white block mt-2">Businesses</span>
                </h1>
              </div>
              
              <p className="text-lg text-slate-300 max-w-xl leading-relaxed">
                WealthWiseConsulting helps service organizations improve performance, profitability, and long-term value through precision-built AI systems and operational consulting.
              </p>

              <div className="flex items-center gap-4 pt-4">
                <button 
                  onClick={() => setShowBookingModal(true)}
                  className="px-10 py-4 bg-white text-slate-900 rounded-full font-semibold hover:bg-slate-100 transition-all shadow-lg hover:shadow-xl flex items-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  Book a Strategy Call
                  <i className="ri-arrow-right-line"></i>
                </button>
                <a 
                  href="#approach"
                  className="px-10 py-4 border border-white text-white rounded-full font-semibold hover:bg-white/10 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  Explore Our Approach
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* Right Visual */}
            <div className="hidden lg:block relative">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=floating%203D%20dashboard%20interface%20showing%20AI%20analytics%20and%20business%20intelligence%20metrics%2C%20translucent%20glass%20morphism%20design%20with%20cyan%20and%20violet%20glowing%20elements%2C%20modern%20data%20visualization%20charts%20and%20workflow%20diagrams%2C%20professional%20consulting%20technology%2C%20dark%20background%20with%20depth%20and%20layers&width=800&height=900&seq=hero-visual-001&orientation=portrait"
                  alt=""
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent rounded-2xl"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-white/50 rounded-full"></div>
          </div>
        </div>
      </div>

      {showBookingModal && <BookingModal onClose={() => setShowBookingModal(false)} />}
    </>
  );
}
